module.exports = {
  title: 'Staggered Card Number Input with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-03-06',
  slug: 'staggered-card-number',
  tags: ['reanimated'],
};
